import { connect } from 'react-redux';

import { MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { UserIdentityMigrationBanner, UserIdentityMigrationBannerOwnProps, UserIdentityMigrationBannerStateProps } from '~src/authentication/components/UserIdentityMigrationBanner';
import { SessionServerSelectors, SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { AppState } from '~src/bootstrap/redux/state/AppState';

const mapStateToProps: MapStateToProps<UserIdentityMigrationBannerStateProps> = (state: AppState) => ({
    urls: siteUrlsSelector(state),
    doesTheServerHaveMoreThanOneSite: SessionServerSelectors.doesTheServerHaveMoreThanOneSite(state),
    isServerAdmin: SessionUserSelectors.isSessionServerAdmin(state),
});

export const ConnectedUserIdentityMigrationBanner: React.ComponentClass<UserIdentityMigrationBannerOwnProps> =
  connect(mapStateToProps)(UserIdentityMigrationBanner);
